import { Component, Input } from "@angular/core";
import { SharedImportsModule } from "../shared-imports.module";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-table-controls",
  standalone: true,
  imports: [SharedImportsModule],
  templateUrl: "./table-controls.component.html",
  styleUrl: "./table-controls.component.css",
})
export class TableControlsComponent {
  @Input() addButtonText: string;
  @Input() route: string;
  @Input() columns: Map<string, string>;

  constructor(private dialog: MatDialog) {}
}
